<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte de tratamientos realizados</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_04</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Generación de reporte de tratamientos realizados
        </b-col>
      </b-row>

      <div class="mt-2 col-md-12"></div>

      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(generar)">

        <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">

            <b-col cols="6">
              <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                <label>Fecha de inicio:<validacion/></label>
                <b-input-group size="sm" class="mb-2">
                  <b-form-datepicker placeholder="Fecha inicio"
                                     v-model="filtro.fechaInicio"
                  ></b-form-datepicker>
                </b-input-group>
                <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                <label>Fecha de fin:<validacion/></label>
                <b-input-group size="sm" class="mb-2">
                  <b-form-datepicker placeholder="Fecha fin"
                                     v-model="filtro.fechaFin"
                  ></b-form-datepicker>
                </b-input-group>
                <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider name="tratamiento" :rules="{ required: false }" v-slot="validationContext">
                <label>Tratamiento:</label>
                <v-select style="width: 100%" :clearable="false" :options="listaTratamientos"
                          v-model="filtro.tratamiento"
                          :reduce="(variable) => variable.idTratamiento"
                          label="nombre" placeholder="Selecciona un tratamiento" multiple>
                  <span slot="no-options">No hay tratamientos disponibles</span>
                </v-select>
                <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
              </validation-provider>
            </b-col>

            <b-col cols="6">
              <validation-provider name="especialidad" :rules="{ required: false }" v-slot="validationContext">
                <label>Especialidad:</label>
                <v-select style="width: 100%" :clearable="false" :options="listaEspecialidadesFiltro"
                          :filterable="false"
                          @search="filtroEspecialidades"
                          v-model="filtro.especialidad"
                          :reduce="(variable) => variable.id"
                          label="especialidad" placeholder="Selecciona una especialidad" multiple>
                  <span slot="no-options">No hay tratamientos disponibles</span>
                </v-select>
                <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
              </validation-provider>
            </b-col>
            <b-col cols="12"></b-col>
            <b-col cols="12">
              <div class="espacio"></div>
              <validation-provider name="clinica" :rules="{ required: true }" v-slot="validationContext">
                <label>Clinica:<validacion/></label>

                      <v-select style="width: 100%" :clearable="false" :options="listaClinicas"
                                v-model="filtro.clinica"
                                :reduce="(variable) => variable.idClinica"
                                label="nombreClinica" placeholder="Selecciona una clínica" multiple>
                        <span slot="no-options">No hay clínicas disponibles</span>
                      </v-select>
                      <b-button-group>
                        <b-button
                            class="ml-1"
                            variant="outline-primary"
                            v-b-tooltip.hover
                            title="Seleccionar Todos"
                            @click="seleccionarTodasClinicas()" size="sm">
                          <b-icon icon="check2-all"></b-icon>
                        </b-button>
                        <b-button v-if="filtro.clinica!==undefined && filtro.clinica!==null && filtro.clinica.length > 0"
                                  class="ml-1"
                                  variant="outline-danger"
                                  v-b-tooltip.hover
                                  title="Quitar selección"
                                  @click="deSeleccionarTodasClinicas()" size="sm">
                          <b-icon icon="trash-fill"></b-icon>
                        </b-button>
                      </b-button-group>
                <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
              </validation-provider>
            </b-col>

            <b-col align="right">
              <b-button v-b-tooltip.hover title="Generar reporte" variant="outline-success"
                       type="submit" :disabled="loader">Generar
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>

        </b-form>
      </validation-observer>

      <div class="mt-2 col-md-12"></div>


      <b-row>
        <b-col cols="12">
          <b-table
              :items="datosTabla"
              :fields="fields"
              responsive>

            <template #thead-top="data">
              <b-tr>
                <b-th colspan=""><span class="sr-only">Clínica</span></b-th>

                <b-th variant="secondary" colspan="2" v-for="(item) in fields_extra" v-bind:key="item">
                  {{item.descripcion}}
                </b-th>

              </b-tr>
            </template>

          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";

export default {
  components: {
    Header
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      datosTabla: [],
      fields: [],
      fields_extra: [],
      paginaActual: 1,
      loader: false,
      filtro: {
        fechaInicio: null,
        fechaFin: null,
        clinica: null,
        tratamiento: null,
        especialidad: null
      },
      listaClinicas: [],
      listaClinicasFiltro: [],
      listaTratamientos: [],
      listaEspecialidades: [],
      listaEspecialidadesFiltro: []
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarClinicas();
    this.obtenerTratamientos();
    this.obtenerEspecialidades();
  },
  methods: {
    filtroClinicas(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()

      this.listaClinicasFiltro = this.listaClinicas.filter(em => {
        return em.nombreClinica.toLowerCase().includes(seach.toLowerCase())}
      )
      let a=[];
      a.push(this.listaClinicasFiltro)
      loading(false)
    },
    filtroEspecialidades(busqueda, loading){
      loading(true)
      let seach = busqueda.trim()
      this.listaEspecialidadesFiltro = this.listaEspecialidades.filter(em => {
        return em.especialidad.toLowerCase().includes(seach.toLowerCase())}
      )
      loading(false)
    },
    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
      this.listaClinicasFiltro = this.listaClinicas;
    },
    obtenerTratamientos() {
      this.$http
          .get(this.$api + "catalogos/obtenerTratamientos")
          .then((response) => {
            if (response.data.data) {
              this.listaTratamientos = response.data.data;
            }
          });
    },
    obtenerEspecialidades() {
      this.$http
          .get(this.$api + "catalogos/obtenerEspecialidades")
          .then((response) => {
            if (response.data.data) {
              this.listaEspecialidades = response.data.data;
              this.listaEspecialidadesFiltro = this.listaEspecialidades;
            }
          });
    },
    seleccionarTodasClinicas() {
      this.filtro.clinica = JSON.parse(JSON.stringify(this.listaClinicas)).map(it=>it.idClinica);
    },
    deSeleccionarTodasClinicas() {
      this.filtro.clinica = null;
    },
    generar() {
      this.loader = true;
      this.datosTabla = [];
      this.fields = [];
      this.fields_extra = [];

      const filtro = {
        fechaInicio: this.filtro.fechaInicio !== null ? this.$moment(this.filtro.fechaInicio).format("YYYY-MM-DD") : null,
        fechaFin: this.filtro.fechaFin !== null ? this.$moment(this.filtro.fechaFin).format("YYYY-MM-DD") : null,
        clinica: this.filtro.clinica,
        tratamiento: this.filtro.tratamiento,
        especialidad: this.filtro.especialidad
      };

      this.$http.post(this.$api + 'reportes/tratamientos/realizados', filtro).then(respuesta => {
        if (respuesta.data.data) {

          this.fields.push({key: "clinica", label: "Clínica", sortable: true, stickyColumn: true});

          respuesta.data.data.encabezados.forEach(it => {
            const nombreTrat = it.idTratamiento + it.descripcion.replace(" ", "").toLowerCase();

            this.fields.push({
              key: nombreTrat+'_conp',
              label: 'Con plan',
              sortable: true
            });

            this.fields.push({
              key: nombreTrat+'_sinp',
              label: 'Sin plan',
              sortable: true
            });

            this.fields_extra.push(it);
          });

          respuesta.data.data.tratamientos.forEach(it => {

            const obj = {
              "clinica": it.clinica
            };

            it.tratamientos.forEach(z => {
              const nombreTrat = z.idTratamiento+z.nombreTratamiento.replace(" ", "").toLowerCase();
              obj[nombreTrat+'_conp'] = z.conPlan;
              obj[nombreTrat+'_sinp'] = z.sinPlan;

            })

            this.datosTabla.push(obj);
          });

        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual = 1;
      })
    }
  }
}
</script>

<style scoped>

</style>
